import React from 'react';
import LivrePratRecto from '../../images/PRAT_Recto.jpg';
import LivrePratVerso from '../../images/PRAT_Verso.jpg';
import CoinGourmand from '../../images/CoinGourmand.jpg';

const NouveautesContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Nouveautés 2026</h3>
            <div className="content-section">
                <h4>Création d'un coin des gourmands</h4>
                <div className="product-grid">
                    <div className="product-item">
                         <div className="book-images">
                            <h5>Avec Des biscuits de la biscuiterie des Chateaux à Amboise, Des tartinades de Champignons de la cave de Cyril, Des terrines de chez Gigou à Bonneveau, ...</h5>
                            <img src={CoinGourmand} alt="Livre Prat Recto" className="book-image1" />
                        </div>    
                    </div>
                 </div>
                <h4>Et de nouveaux objets en boutique</h4>
                <div className="product-grid">
                    <div className="product-item">
                         <div className="book-images">
                            <h5>Des Tote-bags, des éventails, des casquettes et de nouveaux magnets et porte clés</h5>
                            <img src={CoinGourmand} alt="Livre Prat Recto" className="book-image1" />
                        </div>    
                    </div>
                 </div>
                <h4>Et 2 nouveaux livres en bibliothéque</h4>
                <div className="product-grid">
                    <div className="product-item">
                         <div className="book-images">
                            <h5>Le livre de Guy Moyer sur l'église de Saint Oustrille à Montoire</h5>
                            <h5>Les 3 livrets de Joseph-Jean Paques sur l'historique des lignes Blois-Pont de Braye et Sargé-Tours</h5>
                         </div>    
                    </div>
                 </div>
                 <h4>A venir découvrir en Boutique</h4>                
            </div>
        </div>
    );
};

export default NouveautesContent;
